module.exports = __webpack_public_path__ + "static/media/5_The Cracked pot_IN.9e482de0.txt";